import { Component, ViewEncapsulation } from '@angular/core';
import { CmsSearchBoxComponent, RoutingService, WindowRef } from '@spartacus/core';
import { CmsComponentData, SearchBoxComponent, SearchBoxComponentService } from '@spartacus/storefront';
import { SearchType } from '../components.models';
import { UigContentSearchService } from '../uig-content-search/uig-content-search.service';

@Component({
    selector: 'app-uig-search-box',
    templateUrl: './uig-search-box.component.html',
    styleUrls: ['./uig-search-box.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigSearchBoxComponent extends SearchBoxComponent {

  searchTypes = Object.values(SearchType).filter(
    (value) => typeof value === 'string'
  ) as string[];

  selectedSearchType: string = SearchType[SearchType.PRODUCT];

  constructor(
    searchBoxComponentService: SearchBoxComponentService,
    componentData: CmsComponentData<CmsSearchBoxComponent>,
    winRef: WindowRef,
    routingService: RoutingService,
    private contentSearchService: UigContentSearchService) {
    super(searchBoxComponentService, componentData, winRef, routingService);
  }

  launchSearchResult( query: string): void {
    this.close();
    if(this.selectedSearchType === SearchType[SearchType.CONTENT]) {
      this.contentSearchService.launchSearchPage(query);
    }
    else {
      this.searchBoxComponentService.launchSearchPage(query);
    }
  }

  avoidReopen(event: UIEvent): void {
    if (this.searchBoxComponentService.hasBodyClass('searchbox-is-active')) {
      this.close();
      event.preventDefault();
    }

    this.launchSearchResult( "");
  }

}
